<template>
  <div id="contact-form" v-if="loaded">
    <Message :message="systemMessage" :type="type" v-if="systemMessage"></Message>
    <h2 class="title">{{$t('contact.title')}}</h2>
    <div class="form-container">
      <div class="subject-container input">
        <span class="label">{{$t('contact.subject')}}</span>
        <!--        <input :placeholder="this.$t('contact.subject')" class="input" name="subject" type="text" v-model="title">-->
        <Multiselect :allow-empty="false"
                     :options="subjects"
                     v-model="title"
                     :deselectLabel="$t('multiselect.deselectLabel')"
                     :placeholder="$t('multiselect.placeholder')"
                     :selectLabel="$t('multiselect.selectLabel')"
                     :selectedLabel="$t('multiselect.selectedLabel')"
        ></Multiselect>
      </div>
      <div class="message-container input">
        <span class="label">{{$t('contact.messageText')}}</span>
        <textarea :placeholder="this.$t('contact.messageText')" cols="50" name="subject" rows="10" type="text"
                  v-model="message"></textarea>
      </div>
    </div>
    <SubmitButton :buttonText="this.$t('contact.submit')" @save="saveHandler" class="send-button"></SubmitButton>
  </div>
  <preloader v-else></preloader>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Message from '@/components/helpers/Message.vue';
import SubmitButton from '@/components/helpers/SubmitButton.vue';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Preloader from '@/components/helpers/Preloader.vue';

const ConfigurationRepository = RepositoryFactory.get('configuration');

export default {
  name: 'ContactForm',
  components: {
    Multiselect,
    Preloader,
    Message,
    SubmitButton,
  },
  data() {
    return {
      title: '',
      message: '',
      type: 'info',
      systemMessage: '',
      loaded: false,
      subjects: [],
    };
  },
  mounted() {
    ConfigurationRepository.requestSubjects(this.$store.getters.token)
      .then(
        (response) => {
          this.subjects = response.subjects;
          this.title = this.subjects[0];
          this.loaded = true;
        },
      );
  },
  methods: {
    saveHandler() {
      this.loaded = false;
      ConfigurationRepository.sendMessage(this.$store.getters.token, {
        message: this.message,
        title: this.title,
      })
        .then(() => {
          this.systemMessage = this.$t('contact.sendMessage');
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
          this.systemMessage = this.$t('errors.genericError');
          this.type = 'error';
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .input {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    margin: 0 auto;
    // color: $baseTextColor;
    @include media('<480px') {
      width: 100%;
    }

    .label {
      font-size: rem(15px);
      font-weight: 900;
      line-height: 40px;

      &.required {
        &:before {
          content: '* ';
          color: $red;
        }
      }
    }

    input, textarea {
      //margin: 20px 0;
      border: 1px solid $border-gray;
      border-radius: 5px;
      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.16);
      font-size: rem(14px);
      padding: 14px 0 14px 30px;
      width: 100%;
      box-sizing: border-box;

    }
  }

  .send-button {
    margin-top: 25px;
  }
</style>
